module.exports = __webpack_public_path__ + "static/elephantstarblanket-52e9cf0c4e544b18dfe912d1bd402959.jpeg";